import {
  $albumCollectionsTableFilters,
  $albumCollectionsTablePage,
  $albumCollectionsTablePageSize,
  $albumCollectionsTableSearch,
  $albumCollectionsTableSort,
  type AlbumCollectionsSortState,
} from '@/entities/album-collections'
import type { GetApiAlbumCollectionsQueryParams } from '@/shared/api'
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '@/shared/lib/query'
import { createStore, sample } from 'effector'
import { createGate } from 'effector-react'

// Gate
export const CollectionsListPageAlbumCollectionsGate = createGate()

// Last state

// Filters
export const $collectionsListPageLatestAlbumCollectionsFilters =
  createStore<GetApiAlbumCollectionsQueryParams>({})
sample({
  source: $albumCollectionsTableFilters,
  clock: CollectionsListPageAlbumCollectionsGate.close,
  target: $collectionsListPageLatestAlbumCollectionsFilters,
})

// Sort
export const $collectionsListPageLatestAlbumCollectionsSort =
  createStore<AlbumCollectionsSortState>({
    field: null,
    order: null,
  })
sample({
  source: $albumCollectionsTableSort,
  clock: CollectionsListPageAlbumCollectionsGate.close,
  target: $collectionsListPageLatestAlbumCollectionsSort,
})

// Page
export const $collectionsListPageLatestAlbumCollectionsPage =
  createStore<number>(DEFAULT_PAGE)
sample({
  source: $albumCollectionsTablePage,
  clock: CollectionsListPageAlbumCollectionsGate.close,
  target: $collectionsListPageLatestAlbumCollectionsPage,
})

// Page size
export const $collectionsListPageLatestAlbumCollectionsPageSize =
  createStore<number>(DEFAULT_PAGE_SIZE)
sample({
  source: $albumCollectionsTablePageSize,
  clock: CollectionsListPageAlbumCollectionsGate.close,
  target: $collectionsListPageLatestAlbumCollectionsPageSize,
})

// Search
export const $collectionsListPageLatestAlbumCollectionsSearch =
  createStore<string>('')
sample({
  source: $albumCollectionsTableSearch,
  clock: CollectionsListPageAlbumCollectionsGate.close,
  fn: (search) => search || '',
  target: $collectionsListPageLatestAlbumCollectionsSearch,
})
